<template>
	<v-container fluid pa-0 dark flat>
		<v-layout row wrap class="inner-container" justify-center mx-5 mt-5>
			<v-flex xs12 justify-center>
				<h1>Nosotros</h1>
				<h3 class="text-duo font-weight-regular mb-2">Conoce más sobre nuestra empresa y como funciona el sistema.</h3>
				<v-divider></v-divider>
			</v-flex>
		</v-layout>
		<v-layout row wrap class="inner-container" justify-center mt-5
			:class="{'mx-0': $vuetify.breakpoint.smAndDown, 'mx-5': $vuetify.breakpoint.mdAndUp}">
			<v-flex xs12 md4 justify-center>
				<div class="nosotros-how-container text-xs-center">
					<img :src='require("../../assets/static/img/form.png")' alt="formulario" width="150px">
					<h2>Cotiza tu mudanza</h2>
					<p>Utiliza nuestro cotizador en línea, podrás agregar todos los elementos que deseas trasladar y obtener el valor de tu mudanza</p>
				</div>
			</v-flex>
			<v-flex xs12 md4 justify-center>
				<div class="nosotros-how-container text-xs-center">
					<img :src='require("../../assets/static/img/conversation.png")' alt="confirmacion" width="150px">
					<h2>Confirmación</h2>
					<p>Una vez que apruebes el presupuesto y realizado el pago mínimo, nos comunicaremos contigo para coordinar todo y confirmar tu mudanza</p>
				</div>
			</v-flex>
			<v-flex xs12 md4 justify-center>
				<div class="nosotros-how-container text-xs-center">
					<img :src='require("../../assets/static/img/moving-truck.png")' alt="camión" width="150px">
					<h2>Traslado</h2>
					<p>Ya está todo listo para comenzar con el traslado de tus pertenencias en las fechas coordinadas para esto</p>
				</div>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-center>
			<v-flex xs12 justify-center class="text-xs-center sobre-text">
				<div class="sobre-text-inner inner-container white--text">
					<h2>Duo es el puente que conecta clientes y transportistas</h2>
					<p>Seleccionamos personas o empresas dedicadas al transporte de carga en Santiago, que realizan servicios de Fletes o mudanzas. A través de nuestra plataforma puedes cotizar un servicio, contratarlo y pagarlo.</p>
					<p>En 3 simples pasos podrás contar con una cotización y quedarte tranquilo, uno de nuestros transportistas realizará tu Mudanza.</p>
					<p>El servicio incluye las personas que harán el trabajo de mover tus cosas y el vehículo adecuado.</p>
					<p>El mobiliario y los electrodomésticos son separados dentro del vehículo con tela o cartón cuando es necesario. Solo embalamos cuando lo requieras y tiene costo adicional. La idea es hacerlo de manera simple y eficiente, para que ahorres y puedas invertir tu tiempo en lo que realmente importa, tu nuevo hogar.</p>
				</div>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
  export default {
  	name: 'Nosotros',
	title: 'Sobre DUO',
    data: () => ({
    })
  }
</script>
<style>
	.sobre-text{
	background-image: url('../../assets/static/img/couple-mov.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
	}
</style>